import React from 'react';
import { Card, CardContent, Grid } from '@material-ui/core';
import { Typography } from '@mui/material';

const NoDataCard = ({
  height,
  borderRadius,
  customText,
}: {
  height: number;
  borderRadius: number;
  customText?: string;
}) => {
  return (
    <Card style={{ borderRadius: borderRadius ? borderRadius : 'none', width: '100%' }}>
      <CardContent>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ height: height }}
        >
          <Typography variant="body1" textAlign="center" sx={{ fontSize: '18px' }}>
            {customText || 'No Data Available'}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default React.memo(NoDataCard);
